/* Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved. */

// Rotates through the existing accent-* design tokens (tok-040) so client
// avatars are visually distinguishable in list/table views, without
// maintaining a per-client color assignment anywhere.
const AVATAR_ACCENTS = [
  'var(--accent-terracota)',
  'var(--accent-petroleo)',
  'var(--accent-ambar)',
  'var(--accent-salvia)',
  'var(--accent-ameixa)',
  'var(--accent-marinho)',
  'var(--accent-cobre)',
  'var(--accent-oliva)',
  'var(--accent-mostarda)',
  'var(--accent-uva)',
] as const;

/**
 * Deterministically maps a client's full name to one of the accent tokens,
 * so the same client always renders with the same avatar color.
 *
 * @param fullName - The client's full name.
 * @returns A `var(--accent-*)` color for use as the avatar background.
 */
export function getClientAvatarAccentColor(fullName: string | null | undefined): string {
  if (!fullName) return 'var(--seed-base)';
  let hash = 0;
  for (let i = 0; i < fullName.length; i += 1) {
    /**
     * One step of a simple string hash: multiply the running total by 31
     * and fold in the next character code.
     */
    hash = (hash * 31 + fullName.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % AVATAR_ACCENTS.length;
  return AVATAR_ACCENTS[index];
}
